<template>
<custom-dialog :btn-list="['知道了']" @btn-click="close">
<div class="error-dialog">
  <div class="error-dialog-header">信息审核未通过</div>
  <div class="error-dialog-desc">若识别结果与真实信息不符，请尝试重新上传图片或修改信息</div>
  <div class="error-dialog-content">
    <div class="error-dialog-block" v-for="group in groups" :key="group.title">
      <div class="error-dialog-block-header">{{group.title}}</div>
      <template v-if="group.type === 'list'">
        <div class="error-dialog-item" v-for="item in group.list" :key="item.field">
          <div class="error-dialog-item-label">{{item.field}}</div>
          <div class="error-dialog-item-val">{{item.desc}}</div>
        </div>
      </template>
      <template v-else>
        <p>{{group.content}}</p>
      </template>
    </div>
  </div>
</div>
</custom-dialog>
</template>

<script>
import CustomDialog from './custom-dialog'
export default {
  components: {
    CustomDialog
  },
  props: {
    groups: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/variable.styl';

.error-dialog {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  color: $ucar_font_color;

  .error-dialog-header {
    margin: 0 0 30px;
    line-height: 1;
    font-size: $ucar_font_h4;
  }

  .error-dialog-desc {
    margin-bottom: 30px;
    line-height: 1;
    font-size: $ucar_font_h5;
  }

  .error-dialog-content {
    width: 100%;
    
    .error-dialog-block {
      background-color: $ucar_light_bg;
      border: 1PX solid $ucar_light_border;
      padding: 30px;

      .error-dialog-block-header {
        line-height: 1;
        color: $ucar_font_color;
        font-weight: bolder;
        margin-bottom: 30px;
      }

      .error-dialog-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .error-dialog-item + .error-dialog-item {
        margin-top: 30px;
      }

      .error-dialog-item-label, .error-dialog-item-val {
        max-width: 50%;
        line-height: 1;
        font-size: $ucar_font_h5;
      }

      .error-dialog-item-val {
        color: $ucar_label_color;
      }

      p {
        font-size: $ucar_font_h5;
        line-height: 1.5;
      }
    }

    .error-dialog-block + .error-dialog-block {
      margin-top: 30px;
    }
  }
}
</style>